export const GET_OWNERS_CACHE_KEY = 'ownersCache';
export const GET_APPS_CACHE_KEY = 'appsCache';
// My Page — published section. Keyed per user; stores the resolved app_id list.
export const MY_PUBLISHED_CACHE_KEY = 'myPublishedCache';
// My Page — unpublished sections. Keyed per user (see cache key builders).
export const MY_UNPUBLISHED_CACHE_KEY = 'myUnpublishedCache';
// Close Portal — team applications. Keyed per team LDAP group.
export const TEAM_APPS_CACHE_KEY = 'teamAppsCache';

export const cacheVariables = {
	[GET_OWNERS_CACHE_KEY]:{
		expiry: 8 * 60 * 60 * 1000, 
		useCache: true 
	},
	[GET_APPS_CACHE_KEY]:{
		expiry: 1 * 60 * 60 * 1000,
		useCache: true
	},
	[MY_PUBLISHED_CACHE_KEY]:{
		expiry: 1 * 60 * 60 * 1000,
		useCache: true
	},
	[MY_UNPUBLISHED_CACHE_KEY]:{
		expiry: 1 * 60 * 60 * 1000,
		useCache: true
	},
	[TEAM_APPS_CACHE_KEY]:{
		expiry: 1 * 60 * 60 * 1000,
		useCache: true
	}
}
